import React from "react";
import { Star, Globe2, PackageCheck, BadgeCheck } from "lucide-react";
import { stats } from "../mock";

const icons = [Star, PackageCheck, BadgeCheck, Globe2];

export default function Stats() {
  return (
    <section id="about" className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <p className="inline-block text-teal-600 font-bold uppercase tracking-widest text-xs bg-teal-50 px-4 py-1.5 rounded-full mb-4">Our Milestone &amp; Network Achievements</p>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 leading-tight">Ensuring Safe, Legal &amp; Worldwide Medicine Access for All</h2>
          <p className="mt-4 text-slate-600 leading-relaxed">
            ShipMeds is a premier international pharmaceutical logistics courier in India. Guided by the mission of care, safety, and speed, we deliver health home to your family overseas.
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {stats.map((s, i) => {
            const Icon = icons[i] || Star;
            return (
              <div key={s.label} className="group relative rounded-2xl border border-slate-100 card-shadow p-7 text-center bg-white hover:-translate-y-1.5 transition-all duration-300 overflow-hidden">
                <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-teal-500 to-blue-500 scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
                <div className="w-12 h-12 mx-auto mb-3 rounded-2xl bg-gradient-to-br from-teal-50 to-blue-50 text-teal-600 flex items-center justify-center group-hover:from-teal-500 group-hover:to-blue-600 group-hover:text-white transition-colors">
                  <Icon className="w-6 h-6" />
                </div>
                <div className="text-3xl sm:text-4xl font-extrabold bg-gradient-to-r from-teal-600 to-blue-600 bg-clip-text text-transparent">{s.value}</div>
                <div className="mt-1.5 text-sm font-medium text-slate-600">{s.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
